import { JsonObject, JsonProperty } from 'json2typescript';
import { ModelEntity, UtilsString } from '@pit/core';
import { IDtoResourceFaultType } from '../interfaces/dto.resource.fault.type.interface';
import { IDtoMandator } from '../interfaces/dto.mandator.interface';
import { DtoMandator } from './dto.mandator';

// @dynamic
@JsonObject('DtoResourceFaultType')
export class DtoResourceFaultType extends ModelEntity implements IDtoResourceFaultType {

    constructor(initValues: Partial<IDtoResourceFaultType> = null) {
        super();

        if (initValues !== null) {
            Object.assign(this, initValues);
        }
    }

    @JsonProperty('code', String, true)
    public code?: string = null;

    @JsonProperty('description', String, true)
    public description?: string = null;

    @JsonProperty('isVisible', Boolean, true)
    public isVisible?: boolean = true;

    @JsonProperty('mandator', DtoMandator, true)
    public mandator?: IDtoMandator = null;

}
